import { ObservableObject } from "@yulintu/freesia-bootstrap";
export default ObservableObject;